(function () {
  'use strict';
  angular.module('vcpatdocs')
    .component('testpdf', {
      restrict: 'E',
      bindings: {},
      template: `
          <div class="spacer-bottom"><a class="btn btn-info" uib-tooltip="PDF Vorschau"  target="_blank"
                  href="/routes/fop/prescription/false/false/571d67207c01594fd0bbdf45">
            <i class="fa fa-eye"></i> Rezept</a></div>
          <div class="spacer-bottom"><a class="btn btn-info" uib-tooltip="PDF Vorschau" target="_blank"
                  href="/routes/fop/aide/false/false/586fcf4fa60359ae2a632d64/58f88208b148b776e918dd0d">
            <i class="fa fa-eye"></i> Hilfsmittel</a></div>
          <div class="spacer-bottom"><a class="btn btn-info" uib-tooltip="PDF Vorschau" target="_blank"
                  href="/routes/fop/referral/false/false/586fcf4fa60359ae2a632d64/58f88208b148b776e918dd0d">
            <i class="fa fa-eye"></i> Überweisung</a></div>
          <div class="spacer-bottom"><a class="btn btn-info" uib-tooltip="PDF Vorschau" target="_blank"
                  href="/routes/fop/exam/false/false/58f8820cb148b776e918dd0e/58f88208b148b776e918dd0d">
            <i class="fa fa-eye"></i> Untersuchung</a></div>
                      <div class="spacer-bottom"><a class="btn btn-info" uib-tooltip="PDF Vorschau" target="_blank"
                  href="/routes/fop/examlabels/false/false/59c7db409593e058516aa638">
            <i class="fa fa-eye"></i> Untersuchungs Labels</a></div>   
          <div class="spacer-bottom"><a class="btn btn-info" uib-tooltip="PDF Vorschau" target="_blank"
                  href="/routes/fop/consult/false/false/58f88208b148b776e918dd0d">
            <i class="fa fa-eye"></i> Gesamtbefund</a></div>      
      `,
      controllerAs: 'vm',
      controller: ['$log', 'Rlog', '$timeout',
        function ($log, Rlog, $timeout) {
          let vm = this;
/*          vm.testPrescriptionPreview = testPrescriptionPreview;
          vm.testPrescriptionPrint = testPrescriptionPrint;*/

/*
          function testPrescriptionPreview() {
            PatdocaggregateHelper.prescriptionpreview('571d67207c01594fd0bbdf45');
          }

          function testPrescriptionPrint() {
            PatdocaggregateHelper.prescriptionprint('571d67207c01594fd0bbdf45');
          }*/

vm.getUrl = function () {

}
        }
      ] // controller
    }); // component

// klammerfriedhof
}());